import { render, staticRenderFns } from "./BlackMicropoint.vue?vue&type=template&id=20a03499&scoped=true&"
import script from "./BlackMicropoint.vue?vue&type=script&lang=js&"
export * from "./BlackMicropoint.vue?vue&type=script&lang=js&"
import style0 from "./BlackMicropoint.vue?vue&type=style&index=0&id=20a03499&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a03499",
  null
  
)

export default component.exports